// extracted by mini-css-extract-plugin
module.exports = {"container":"GenericScreen_container__1090w","page":"GenericScreen_page__2BHVA"};